// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Q_B0y","label":"Category_label__3a1pf","content":"Category_content__2hAqF","header":"Category_header__2j5fc","location":"Category_location__1H6Fk"};